import { render, staticRenderFns } from "./cabGroup.vue?vue&type=template&id=5b47518e&scoped=true&"
import script from "./cabGroup.vue?vue&type=script&lang=js&"
export * from "./cabGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b47518e",
  null
  
)

export default component.exports